/* eslint-disable react/require-default-props */
import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {DownlineProfile} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {generateCallback} from '/util/component.util';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './Checkbox.style';

interface CheckboxProps {
  getTheme: (key: string) => string;
  onChange: (value: boolean) => void;
  checked: boolean;
  disabled: boolean;
  readonly: boolean;
  checkedIconName: string | null;
  style?: {
    icon?: any;
  };
  rectangleCheckbox: boolean;
  accessible: boolean;
  accessibilityLabel: string;
  accessibilityRole: string;
  containerStyle?: Object;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  getTheme = noop,
  accessible = false,
  accessibilityLabel = '',
  accessibilityRole = 'checkbox',
  onChange,
  checked,
  disabled,
  readonly,
  checkedIconName,
  style: styleProps,
  rectangleCheckbox,
  containerStyle = {},
}) => {
  const style = [styles.base, containerStyle];

  const iconStyle = {
    ...styles.icon,
    ...(styleProps?.icon || {}),
    ...(checked
      ? {color: getTheme('competency.textColor')}
      : styles.iconUnchecked),
    ...(disabled ? styles.iconDisabled : {}),
  };

  const checkedIcon = checkedIconName || 'circle-checkmark-filled';
  const iconName = checked ? checkedIcon : 'circle';
  if (readonly || disabled) {
    return (
      <View
        accessible={accessible}
        accessibilityLabel={accessibilityLabel}
        style={style}
        {...testProperties(rectangleCheckbox ? checkedIconName : iconName)}>
        <Icon
          name={rectangleCheckbox ? checkedIconName : iconName}
          style={rectangleCheckbox ? styleProps?.icon : iconStyle}
          accessible={false}
          accessibilityElementsHidden={true}
          importantForAccessibility="no-hide-descendants"
        />
      </View>
    );
  } else {
    return (
      <TouchableOpacity
        accessible={accessible}
        accessibilityLabel={accessibilityLabel}
        accessibilityRole={accessibilityRole}
        onPress={generateCallback({func: onChange, params: !checked})}
        style={style}
        {...testProperties(
          `${DownlineProfile.checkBox}${checked ? 'checked' : 'unchecked'}`,
        )}>
        <Icon
          name={rectangleCheckbox ? checkedIconName : iconName}
          style={rectangleCheckbox ? styleProps?.icon : iconStyle}
          accessible={false}
          accessibilityElementsHidden={true}
          importantForAccessibility="no-hide-descendants"
        />
      </TouchableOpacity>
    );
  }
};

export default withHOC(withTheme, withCompetency)(Checkbox);
